<template>
<div class="body-main">
  <div class="header">
<!--    <el-button size="mini" @click="editor()">添加</el-button>-->
    <el-button type="primary" size="mini" @click="pageChange(1)">搜索</el-button>
    <el-input v-model="where2.keyword" style="width: 200px;margin-left: 10px;" size="mini" placeholder="请输入名称" clearable></el-input>

<!--    <el-select v-model="where2.status" class="m-2" filterable placeholder="选择合作状态" clearable style="margin-left: 10px;" size="mini">-->
<!--      <el-option-->
<!--        v-for="item in [{name:'终止合作',value:0},{name:'合作中',value:1}]"-->
<!--        :key="item.value"-->
<!--        :label="item.name"-->
<!--        :value="item.value"-->
<!--      />-->
<!--    </el-select>-->
    <!--        状态：1未结算，2结算审核中，3审核通过，4作废-->
    <el-select size="mini" v-model="where2.status" placeholder="选择结算状态">
      <el-option
        v-for="item in [{name:'未结算',value:1},{name:'结算审核中',value:2},{name:'审核通过',value:3},{name:'作废',value:4}]"
        :key="item.value"
        :label="item.name"
        :value="item.value"
      />
    </el-select>
    <el-date-picker
      style="width: 150px"
      v-model="where2.year_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" @change="getList()">
    </el-date-picker>
  </div>
  <div class="table-wrap">
    <el-table
      v-loading="loading" :data="pageData.data"
      border
      @sort-change="onSorTable"
      style="width: 100%" height="60vh">
      <el-table-column
        prop="project_name"
        label="项目"
        width="200" align="center" sortable="custom" fixed></el-table-column>
      <el-table-column
        prop="company_name"
        label="第三方单位名称" width="240" align="center" sortable="custom" fixed></el-table-column>
      <el-table-column label="催缴信息" align="center">
        <el-table-column
          align="center"
          sortable="custom"
          prop="collection_num"
          label="催缴次数"
          width="150">
        </el-table-column>
        <el-table-column
          align="center" sortable="custom"
          prop="collection_house_num"
          label="催缴户数"
          width="150">
        </el-table-column>
        <el-table-column
          align="center" sortable="custom"
          prop="collection_house_rate"
          label="催缴率"
          width="150">
        </el-table-column>
        <el-table-column
          align="center" sortable="custom"
          prop="payment_collection_num"
          label="回款户数"
          width="150">
        </el-table-column>
        <el-table-column
          align="center" sortable="custom"
          prop="payment_collection_amount"
          label="回款金额"
          width="150">
          <template slot-scope="scope">
            <span style="color: #ff3d00;font-size: 16px;font-weight: bold;">{{(scope.row.payment_collection_amount||0)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center" sortable="custom"
          prop="payment_collection_rate"
          label="回款率"
          width="150">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center" sortable="custom"
        prop="service_rate"
        label="结算费率(%)"
        width="100">
      </el-table-column>
      <el-table-column sortable="custom"
                       align="center"
                       prop="money"
                       label="系统计算金额"
                       width="150">
        <template slot-scope="scope">
          <span style="color: #ff3d00;font-size: 16px;font-weight: bold;">{{(scope.row.money||0)}}</span>
        </template>
      </el-table-column>
      <el-table-column sortable="custom"
        align="center"
        prop="paid_money"
        label="结算金额"
        width="150">
        <template slot-scope="scope">
          <span style="color: #ff3d00;font-size: 16px;font-weight: bold;">{{(scope.row.paid_money||0)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center"
        prop="month_status"
        label="状态"
        width="100">
<!--        状态：1未结算，2结算审核中，3审核通过，4作废-->
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.month_status===1">未结算</el-tag>
          <el-tag type="warning" v-if="scope.row.month_status===2">结算审核中</el-tag>
          <el-tag type="success" v-if="scope.row.month_status===3">审核通过</el-tag>
          <el-tag type="danger" v-if="scope.row.month_status===4">作废</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable="custom"
        prop="updated_at"
        label="更新时间"
        width="100">
      </el-table-column>
      <el-table-column align="center"
        label="操作"
        min-width="200" fixed="right">
        <template slot-scope="scope">
          <div v-if="scope.row.payment_collection_amount>0">
            <el-link type="primary" size="mini" v-if="scope.row.month_status===1" @click="computeMoney(scope.row)">费用计费</el-link>
            <el-link type="primary" size="mini" v-if="scope.row.month_status===1&&scope.row.money>0" @click="startFlow(scope.row)">流程审批</el-link>
            <el-link type="primary" size="mini" v-if="scope.row.month_task_id" @click="openFlow(scope.row)">查看流程</el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination
      @current-change="pageChange"
      :current-page="pageData.current_page"
      :page-size="pageData.per_page"
      layout="total, prev, pager, next"
      :total="pageData.total">
    </el-pagination>
  </div>

  <el-dialog title="详情" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="500px">

    <el-descriptions :column="1" size="mini" border>
      <el-descriptions-item label="单位名称">
        <el-input v-model="formData.name" size="mini" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="负责人">
        <el-input v-model="formData.head_name" size="mini" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="联系电话">
        <el-input v-model="formData.telephone" size="mini" clearable></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="状态">
        <el-select v-model="formData.status" class="m-2" filterable placeholder="选择状态" clearable size="mini">
          <el-option
            v-for="item in [{name:'终止合作',value:0},{name:'合作中',value:1}]"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
      </el-descriptions-item>
      <el-descriptions-item label="备注">
        <el-input v-model="formData.remark" size="mini" clearable></el-input>
      </el-descriptions-item>
    </el-descriptions>

    <template #footer>
      <div style="">
        <el-button size="mini" @click="dialogVisible=false">取消</el-button>
        <el-button size="mini" @click="save">确认</el-button>
      </div>
    </template>
  </el-dialog>

  <ViewFlow ref="viewFlowRef" />
  <ThirdPartyCompanyProjectMonthDetailsDialog ref="thirdPartyCompanyProjectMonthDetailsDialogRef" />
</div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";
import moment from "moment";
import ViewFlow from "../../../Common/ViewFlow";
import ThirdPartyCompanyProjectMonthDetailsDialog from "./ThirdPartyCompanyProjectMonthDetailsDialog";

export default {
  name: "ThirdPartyCompanyProjectMonth",
  components: {ThirdPartyCompanyProjectMonthDetailsDialog, ViewFlow},
  inject:['where','reginWhere'],
  props:{
    urge_type:{
      type:Number,
      default:3
    }
  },
  data(){
    return{
      where2:{
        keyword:"",
        status:"",
        month_status: "",
        order_by:"",
        year_month:moment().format("YYYY-MM"),
      },
      pageData: {
        current_page: 1,
        per_page: 20,
        data:[],
        total:0
      },
      loading: false,
      formData:{
        name:"",
        head_name:"",
        telephone:"",
        status:1,
        remark:""
      },
      dialogVisible:false,
    }
  },
  mounted() {
    this.pageChange(1)
  },
  methods:{
    getList() {
      const that = this;
      that.loading = true;
      let where = ERP.reJson(that.where2)
      where = {
        ...where,
        ...ERP.reJson(that.where),
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        urge_type:that.urge_type,
        // area_id:that.areaId
      }

      ButlerHttp.post("ThirdPartyCommon/getProjectCompanyMonthList?page="+that.pageData.current_page+"&per_page="+that.pageData.per_page, {
        ...where
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      this.pageData.current_page = i
      this.getList()
    },
    editor(item=null){
      const that=this;
      if(!item) {
        that.formData={
          name:"",
          head_name:"",
          telephone:"",
          status:1,
          remark:""
        }
      }else {
        that.formData=item;
      }
      that.dialogVisible=true;
    },
    stop(){
      const that = this;
      that.$confirm('停止第三方合作的前提是当前合作商无催缴房产了，确定吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let formData = ERP.reJson(that.formData)
        ButlerHttp.post("ThirdPartyLegal/getProjectCompanyStop", {
          id: formData.id
        }, res => {
          if (res.code) {
            that.pageChange(1);
          } else {
            that.$message.error(res.msg || '操作异常');
          }
        });
      })
    },
    save(){
      const that = this;
      that.loading = true;
      let formData = ERP.reJson(that.formData)
      ButlerHttp.post("ThirdPartyLegal/getCollectionThridCompanyEditor", formData, res => {
        if (res.code) {
          that.dialogVisible = false;
          that.pageChange(1);
        } else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    },

    deleteItem(item){
      const that=this;

      ButlerHttp.post("ThirdPartyLegal/getCollectionThridCompanyDel", {
        id: item.id
      }, res => {
        if (res.code) {
          that.getList();
        } else {
          that.$message.error(res.msg || '操作异常');
        }
      });
    },
    onClose(){

    },
    onSorTable({column, prop, order}){
      console.log({column, prop, order})
      const that=this;
      if(order){
        let orderProp={
          "project_name":"cp.project_name",
          "company_name":"c.name",
          "start_time":"cp.start_time",
          "end_time":"cp.end_time",
          "house_count":"cp.house_count",
          "house_money":"cp.house_money",
          "collection_num":"cps.collection_num",
          "collection_house_num":"cps.collection_house_num",
          "collection_house_rate":"cps.collection_house_rate",
          "payment_collection_num":"cps.payment_collection_num",
          "payment_collection_amount":"cps.payment_collection_amount",
          "payment_collection_rate":"cps.payment_collection_rate",
          "service_rate":"cps.service_rate",
          "money":"cps.money",
          "paid_money":"cps.paid_money",
          "updated_at":"cp.updated_at",
        }
        let sortOrder = order === 'ascending' ? 'asc' : 'desc'; // 转换为后端期望的格式（例如 'asc'/'desc'）
        let field=orderProp[prop]||null
        if(field) {
          that.where2.order_by=`${field} ${sortOrder}`
        }else {
          that.where2.order_by=''
        }
      }else {
        that.where2.order_by=''
      }
      that.pageChange(1);

    },
    startFlow(item){
      const that=this;
      let timeValue=(new Date()).getTime();
      ERP.navigateTo(`/flow/FlowView?sheet_id=313&master_id=253&timeValue=${timeValue}&batch_number=${item.cps_id}&service_rate=${item.service_rate}&money=${item.money}&paid_money=${item.paid_money}`)
    },
    openFlow(item){
      const that=this;
      that.$refs.viewFlowRef.show({
        task_id:item.month_task_id,
      })
    },
    computeMoney(item){
      const that=this;
      that.$refs.thirdPartyCompanyProjectMonthDetailsDialogRef.show({data:item,year_month: that.where2.year_month},function () {
        that.pageChange(1)
      })
    },
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1)
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1)
    },
    "where2.keyword":function (n,o) {
      this.pageChange(1)
    },
    "where2.status":function (n,o) {
      this.pageChange(1)
    },
    "where.thrid_company_id":function (n,o) {
      this.pageChange(1)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.body-main{
  .header{
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
  }
  .table-wrap{
    >>>.el-table--border, .el-table--group{
      border: 1px solid #000000;
    }
    >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
      border-bottom: 1px solid #000000;
    }
    >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
      border-right: 1px solid #000000;
    }
    >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
      border-bottom: 1px solid #000000;
    }
    >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
      border-bottom: 1px solid #000000;
    }
  }
  .pagination-wrap{
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThirdPartyCompanyProjectMonth.vue